import { render, staticRenderFns } from "./yuebao.vue?vue&type=template&id=0509c06d&scoped=true&"
import script from "./yuebao.vue?vue&type=script&lang=js&"
export * from "./yuebao.vue?vue&type=script&lang=js&"
import style0 from "./yuebao.vue?vue&type=style&index=0&id=0509c06d&prod&lang=less&"
import style1 from "./yuebao.vue?vue&type=style&index=1&id=0509c06d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509c06d",
  null
  
)

export default component.exports